module.exports = __webpack_public_path__ + "img/banner-image.0e470ae2.png";